import { Component, Input } from '@angular/core';
import { HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { PictureDisplay } from '@freelancer/ui/picture';
import { TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-home-page-need-work-done',
  template: `
    <fl-heading
      class="NeedWorkDone-header"
      i18n="Need Work Done Header"
      [size]="TextSize.LARGE"
      [sizeTablet]="TextSize.XLARGE"
      [sizeDesktop]="TextSize.XXXLARGE"
      [headingType]="HeadingType.H2"
      [flMarginBottom]="Margin.MID"
      [flMarginBottomTablet]="Margin.XLARGE"
      [flMarginBottomDesktop]="Margin.XXXXLARGE"
    >
      Need something done?
    </fl-heading>

    <fl-grid *ngIf="!isRedesign">
      <fl-col
        [col]="12"
        [colDesktopSmall]="4"
        [flMarginBottom]="Margin.LARGE"
        [flMarginBottomTablet]="Margin.XLARGE"
        [flMarginBottomDesktop]="Margin.NONE"
      >
        <fl-bit
          class="NeedWorkDone-item-header"
          [flMarginBottom]="Margin.XXSMALL"
          [flMarginBottomDesktop]="Margin.LARGE"
        >
          <fl-picture
            class="NeedWorkDone-item-header-image"
            alt="Post a Job Icon"
            i18n-alt="Post a Job Icon Alternative Text"
            [ngClass]="{
              'NeedWorkDone-item-header-image--hidden': !isPostJobIconReady
            }"
            [src]="'home/need-work-done/post-a-job-v3.svg'"
            [fullWidth]="true"
            [alignCenter]="true"
            [lazyLoad]="true"
            [display]="PictureDisplay.BLOCK"
            [flMarginRight]="Margin.SMALL"
            (imageLoaded)="isPostJobIconReady = true"
          ></fl-picture>

          <fl-heading
            i18n="Post a Job Header"
            [size]="TextSize.SMALL"
            [sizeTablet]="TextSize.LARGE"
            [headingType]="HeadingType.H3"
          >
            Post a job
          </fl-heading>
        </fl-bit>
        <fl-text
          class="NeedWorkDone-item-description"
          i18n="Post a job description"
          [size]="TextSize.SMALL"
          [sizeTablet]="TextSize.MID"
          [sizeDesktop]="TextSize.MARKETING_SMALL"
        >
          It's easy. Simply post a job you need completed and receive
          competitive bids from freelancers within minutes.
        </fl-text>
      </fl-col>

      <fl-col
        [col]="12"
        [colDesktopSmall]="4"
        [flMarginBottom]="Margin.LARGE"
        [flMarginBottomTablet]="Margin.XLARGE"
        [flMarginBottomDesktop]="Margin.NONE"
      >
        <fl-bit
          class="NeedWorkDone-item-header"
          [flMarginBottom]="Margin.XXSMALL"
          [flMarginBottomDesktop]="Margin.LARGE"
        >
          <fl-picture
            class="NeedWorkDone-item-header-image"
            alt="Choose Freelancers Icon"
            i18n-alt="Choose Freelancers Icon Alternative Text"
            [ngClass]="{
              'NeedWorkDone-item-header-image--hidden': !isChooseFreelancersIconReady
            }"
            [src]="'illustrations/work.svg'"
            [fullWidth]="true"
            [alignCenter]="true"
            [lazyLoad]="true"
            [display]="PictureDisplay.BLOCK"
            [flMarginRight]="Margin.SMALL"
            (imageLoaded)="isChooseFreelancersIconReady = true"
          ></fl-picture>

          <fl-heading
            i18n="Choose freelancers Header"
            [size]="TextSize.SMALL"
            [sizeTablet]="TextSize.LARGE"
            [headingType]="HeadingType.H3"
          >
            Choose freelancers
          </fl-heading>
        </fl-bit>
        <fl-text
          class="NeedWorkDone-item-description"
          i18n="Choose freelancers description"
          [size]="TextSize.SMALL"
          [sizeTablet]="TextSize.MID"
          [sizeDesktop]="TextSize.MARKETING_SMALL"
        >
          Whatever your needs, there will be a freelancer to get it done: from
          web design, mobile app development, virtual assistants, product
          manufacturing, and graphic design (and a whole lot more).
        </fl-text>
      </fl-col>

      <fl-col [col]="12" [colDesktopSmall]="4">
        <fl-bit
          class="NeedWorkDone-item-header"
          [flMarginBottom]="Margin.XXSMALL"
          [flMarginBottomDesktop]="Margin.LARGE"
        >
          <fl-picture
            class="NeedWorkDone-item-header-image"
            alt="Pay Safely Icon"
            i18n-alt="Pay Safely Icon Alternative Text"
            [ngClass]="{
              'NeedWorkDone-item-header-image--hidden': !isPaySafelyIconReady
            }"
            [src]="'home/need-work-done/pay-safely-v3.svg'"
            [fullWidth]="true"
            [alignCenter]="true"
            [lazyLoad]="true"
            [display]="PictureDisplay.BLOCK"
            [flMarginRight]="Margin.SMALL"
            (imageLoaded)="isPaySafelyIconReady = true"
          ></fl-picture>

          <fl-heading
            i18n="Pay Safely Header"
            [size]="TextSize.SMALL"
            [sizeTablet]="TextSize.LARGE"
            [headingType]="HeadingType.H3"
          >
            Pay safely
          </fl-heading>
        </fl-bit>
        <fl-text
          class="NeedWorkDone-item-description"
          i18n="Pay safely description"
          [size]="TextSize.SMALL"
          [sizeTablet]="TextSize.MID"
          [sizeDesktop]="TextSize.MARKETING_SMALL"
        >
          With secure payments and thousands of reviewed professionals to choose
          from, Freelancer.com is the simplest and safest way to get work done
          online.
        </fl-text>
      </fl-col>
    </fl-grid>

    <fl-grid *ngIf="isRedesign">
      <fl-col
        class="NeedWorkDone-item--upper"
        [col]="12"
        [colTablet]="6"
        [colDesktopLarge]="3"
        [flMarginBottom]="Margin.XLARGE"
        [flMarginBottomTablet]="Margin.XXXLARGE"
      >
        <app-home-page-article-item
          description="It’s free and easy to post a job. Simply fill in a title, description and budget and competitive bids come within minutes."
          i18n-description="Post a job description"
          heading="Post a job"
          i18n-heading="Post a job heading"
          iconAlt="Post a job Icon"
          i18n-iconAlt="Post a job Icon Alt"
          [iconSrc]="'home/need-work-done/post-a-job-v3.svg'"
        ></app-home-page-article-item>
      </fl-col>
      <fl-col
        class="NeedWorkDone-item--upper"
        [col]="12"
        [colTablet]="6"
        [colDesktopLarge]="3"
        [flMarginBottom]="Margin.XLARGE"
        [flMarginBottomTablet]="Margin.XXXLARGE"
      >
        <app-home-page-article-item
          description="No job is too big or too small. We’ve got freelancers for any size job or budget across 1800+ skills. No job is too complex, we can get it done!"
          i18n-description="Choose freelancers description"
          heading="Choose freelancers"
          i18n-heading="Choose freelancers heading"
          iconAlt="Choose freelancers Icon"
          i18n-iconAlt="Choose freelancers Alt"
          [iconSrc]="'illustrations/work.svg'"
        ></app-home-page-article-item>
      </fl-col>
      <fl-col
        [col]="12"
        [colTablet]="6"
        [colDesktopLarge]="3"
        [flMarginBottom]="Margin.XLARGE"
        [flMarginBottomTablet]="Margin.NONE"
      >
        <app-home-page-article-item
          description="Only pay for work when it has been completed and you're 100% satisfied with the quality using our milestone payment system."
          i18n-description="Pay safely description"
          heading="Pay safely"
          i18n-heading="Pay safely heading"
          iconAlt="Pay safely Icon"
          i18n-iconAlt="Pay safely Alt"
          [iconSrc]="'home/need-work-done/pay-safely-v3.svg'"
        ></app-home-page-article-item>
      </fl-col>
      <fl-col
        [col]="12"
        [colTablet]="6"
        [colDesktopLarge]="3"
        [flMarginBottom]="Margin.XLARGE"
        [flMarginBottomTablet]="Margin.NONE"
      >
        <app-home-page-article-item
          description="Our talented team of recruiters can help you find the best freelancer for the job and our technical co-pilots can even manage the project for you."
          i18n-description="We’re here to help description"
          heading="We’re here to help"
          i18n-heading="We’re here to help heading"
          iconAlt="We’re here to help Icon"
          i18n-iconAlt="We’re here to help Alt"
          [iconSrc]="'illustrations/about-you.svg'"
        ></app-home-page-article-item>
      </fl-col>
    </fl-grid>
  `,
  styleUrls: ['./need-work-done.component.scss'],
})
export class HomePageNeedWorkDoneComponent {
  HeadingType = HeadingType;
  Margin = Margin;
  PictureDisplay = PictureDisplay;
  TextSize = TextSize;

  isPostJobIconReady = false;
  isChooseFreelancersIconReady = false;
  isPaySafelyIconReady = false;

  @Input() isRedesign: boolean;
}
